const tipoPlanoNome = {
  CREDITO_PAGAMETADE: "Paga metade",
  CREDITO_INTEGRAL: "Integral",
  PARCELA_REDUZIDA: "Parcela reduzida",
};

const tipoPlanoNomeCased = {
  CREDITO_PAGAMETADE: "Paga Metade",
  CREDITO_INTEGRAL: "Integral",
  PAGA_REDUZIDA: "Paga Reduzida",
  PAGAMETADE_REDUZIDA: "Paga Metade Reduzida",
};

const planoNome = {
  "Paga Metade": "CREDITO_PAGAMETADE",
  Integral: "CREDITO_INTEGRAL",
  "Paga Reduzida": "PARCELA_REDUZIDA",
};

const TipoSimulacaoEnum = {
  CREDITO_INTEGRAL: "CREDITO_INTEGRAL",
  CREDITO_PAGAMETADE: "CREDITO_PAGAMETADE",
  PARCELA_REDUZIDA: "PARCELA_REDUZIDA",
};

const BOT_NAME = {
  HOME: "HOME",
  APP: "APP",
  PERFORMANCE: "PERFORMANCE",
  OFERTA: "OFERTA",
  ABANDONO_IMOVEL: "ABANDONO_IMOVEL",
  MYCOINS: "MYCOINS",
  LIVE: "LIVE",
  ANIVERSARIO: "ANIVERSARIO",
  ANIVERSARIO_FINAL_DE_SEMANA: "ANIVERSARIO_FINAL_DE_SEMANA",
  FINDE_TURBO: "FINDE_TURBO",
  FINDE: "FINDE",
  CONECTA: "CONECTA",
  CRM: "CRM",
  EXCLUSIVO: "EXCLUSIVO",
  CUPOM: "CUPOM",
  COLLAB_99: "COLLAB_99",
  COLLAB_99_ROTA99: "COLLAB_99_ROTA99",
  COLLAB_99_PAY: "COLLAB_99_PAY",
  COLLAB_PREMMIA: "COLLAB_PREMMIA",
  COLLAB_GAZETA: "COLLAB_GAZETA",
  COLLAB_SALARY_FITS: "COLLAB_SALARY_FITS",
  COLLAB_KMV: "COLLAB_KMV",
  COLLAB_LIVELO: "COLLAB_LIVELO",
  COLLAB_SEM_PARAR: "COLLAB_SEM_PARAR",
  COLLAB_FINANZERO: "COLLAB_FINANZERO",
  COLLAB_CLUBE_CERTO: "COLLAB_CLUBE_CERTO",
  COLLAB_CLUBE_GIRO: "COLLAB_CLUBE_GIRO",
  COLLAB_EASY_CREDITO: "COLLAB_EASY_CREDITO",
  COLLAB_AUTO_MAIS: "COLLAB_AUTO_MAIS",
  COLLAB_AUTO_MAIS_APP: "COLLAB_AUTO_MAIS_APP",
  COLLAB_TRUCADAO: "COLLAB_TRUCADAO",
  COLLAB_STOPCLUB: "COLLAB_STOPCLUB",
  COLLAB_LOGGI: "COLLAB_LOGGI",
};

const TipoBotEnum = {
  [BOT_NAME.HOME]: {
    textChat1:
      "Olá, eu sou o Mycon! Meu aniversário chegou e eu trouxe um combo de ofertas especiais para te dar de presente. Quer conquistar sem juros e sem entrada? Então vem pra festa!",
    textChat2:
      "Comemore a vida com uma conquista importante e que caiba no seu bolso. Simule seu consórcio agora mesmo:",
  },
  [BOT_NAME.APP]: {
    textChat1:
      "Olá, eu sou o Mycon! Meu aniversário chegou e eu trouxe um combo de ofertas especiais para te dar de presente. Quer conquistar sem juros e sem entrada? Então vem pra festa!",
    textChat2:
      "Comemore a vida com uma conquista importante e que caiba no seu bolso. Simule seu consórcio agora mesmo:",
  },
  [BOT_NAME.PERFORMANCE]: {
    textChat1:
      "Olá, eu sou o Mycon! Você encontrou nosso gato da prosperidade por aí, não foi? Agora está mais perto de realizar seu sonho <b>sem juros, sem entrada</b> e com </b>50% OFF</b> na 1ª parcela! ",
    textChat2:
      "Não é sorte, é como todo consórcio deveria ser: seguro, com preço justo e total transparência nos processos! Simule agora mesmo:",
  },
  [BOT_NAME.ABANDONO_IMOVEL]: {
    textChat1:
      "Olá, eu sou o Mycon! E você está prestes a conquistar de uma forma econômica, prática e segura.",
    textChat2:
      "<b>É sem juros, sem entrada</b> e você tem o melhor plano em mãos em poucos cliques.",
  },
  [BOT_NAME.OFERTA]: {
    textChat1:
      "Olá, eu sou o Mycon! Você encontrou nosso gato da prosperidade por aí, não foi? Agora está mais perto de realizar seu sonho <b>sem juros, sem entrada</b> e com <b>30% OFF</b> na 1ª parcela!",
    textChat2:
      "Não é sorte, é como todo consórcio deveria ser: seguro, com preço justo e total transparência nos processos! Simule agora mesmo:",
  },
  [BOT_NAME.MYCOINS]: {
    textChat1:
      "Oi, eu sou o Mycon! E você está prestes a conquistar de uma forma econômica, prática e segura.",
    textChat2:
      "<b>É sem juros, sem entrada</b> e você tem o melhor plano em mãos em poucos cliques.",
  },
  [BOT_NAME.EXCLUSIVO]: {
    textChat1:
      "Olá, eu sou o Mycon! Você encontrou nosso gato da prosperidade por aí, não foi? Agora está mais perto de realizar seu sonho <b>sem juros, sem entrada</b> e com </b>50% OFF</b> na 1ª parcela! ",
    textChat2:
      "Não é sorte, é como todo consórcio deveria ser: seguro, com preço justo e total transparência nos processos! Simule agora mesmo:",
  },
  [BOT_NAME.CUPOM]: {
    textChat1:
      "Olá, eu sou o Mycon! E você está prestes a conquistar de uma forma econômica, prática e segura.",
    textChat2:
      "<b>É sem juros, sem entrada</b> e você tem o melhor plano em mãos em poucos cliques.",
  },
  [BOT_NAME.COLLAB_99]: {
    textChat1:
      "Olá, eu sou o Mycon! Você encontrou o lugar ideal para garantir sua conquista <b>sem juros, sem entrada, e com muita tranquilidade!</b>",
    textChat2:
      "Aqui é <b>como todo consórcio deveria ser:</b> seguro, com preço justo e total transparência nos processos! Vamos simular seu sonho?",
  },
  [BOT_NAME.COLLAB_99_ROTA99]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Eu e a <b>Rota 99</b> oferecemos o jeito mais barato para você, <b>motorista parceiro</b>, comprar seu <b>carro ou moto</b> de forma mais barata.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_99_PAY]: {
    textChat1:
      "Olá, eu sou o <b>Mycon!</b> Junto com a <b>99Pay</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_PREMMIA]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com a <b>Premmia</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_GAZETA]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com <b>A Gazeta</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_SALARY_FITS]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com a <b>SalaryFits</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_KMV]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com a <b>KM de Vantagens</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_LIVELO]: {
    textChat1:
      "Olá, eu sou o Mycon! Junto com a <b>Livelo</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_SEM_PARAR]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com a <b>Sem Parar</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_FINANZERO]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com a <b>Finanzero</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_CLUBE_CERTO]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com a <b>Clube Certo</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_CLUBE_GIRO]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com a <b>Clube Giro</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_EASY_CREDITO]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com a <b>Easy Crédito</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_AUTO_MAIS]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com a <b>Auto Mais</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_AUTO_MAIS_APP]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Comprando hoje, você paga apenas a <b>METADE</b> das parcelas até ser contemplado e ainda <b>ganha 50% de desconto</b> na primeira parcela!",
    textChat2:
      "Essa é uma condição <b>EXCLUSIVA</b> que eu e o <b>Auto+</b> preparamos para você, usuário do app, comprar aquilo que deseja de forma mais barata. <b>Corre pra aproveitar!</b>",
  },
  [BOT_NAME.COLLAB_TRUCADAO]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com o <b>Trucadão</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_STOPCLUB]: {
    textChat1:
      "Olá, eu sou o Mycon!</b> Junto com o <b>StopClub</b>, estamos oferecendo o <b>jeito mais barato</b> para você <b>comprar</b> tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio <b>sem juros, sem entrada</b> e com a <b>melhor taxa do Brasil.</b> Simule!",
  },
  [BOT_NAME.COLLAB_LOGGI]: {
    textChat1:
      "Olá, eu sou o Mycon! Junto com a Loggi, estamos oferecendo o jeito mais barato para você comprar tudo aquilo que deseja.",
    textChat2:
      "Faça agora seu consórcio sem juros, sem entrada e com a melhor taxa do Brasil. Simule!",
  },
};

const ProdutosEnum = {
  IMOVEL: "IMOVEL",
  CARRO: "CARRO",
  MOTO: "MOTO",
  SERVICO: "SERVICO",
  CAMINHAO: "CAMINHAO",
  MAQUINAS: "MAQUINAS",
};

const ProdutosNomes = {
  IMOVEL: "IMÓVEL",
  CARRO: "CARRO",
  MOTO: "MOTO",
  SERVICO: "SERVIÇO",
  CAMINHAO: "CAMINHÃO",
  MAQUINAS: "MÁQUINAS",
};

const ProdutosNomesCopy = {
  IMOVEL: "seu <b>IMÓVEL</b>",
  CARRO: "seu <b>CARRO</b>",
  MOTO: "sua <b>MOTO</b>",
  SERVICO: "seu <b>SERVIÇO</b>",
  CAMINHAO: "seu <b>CONSÓRCIO</b>",
  MAQUINAS: "seu <b>CONSÓRCIO</b>",
};

const valoresSimulacao = {
  [TipoSimulacaoEnum.CREDITO_INTEGRAL]: {
    [ProdutosEnum.IMOVEL]: { min: 100000, max: 700000 },
    [ProdutosEnum.CARRO]: { min: 30000, max: 400000 },
    [ProdutosEnum.MOTO]: { min: 10000, max: 120000 },
    [ProdutosEnum.SERVICO]: { min: 12000, max: 20000 },
    [ProdutosEnum.CAMINHAO]: { min: 100000, max: 400000 },
    [ProdutosEnum.MAQUINAS]: { min: 100000, max: 400000 },
  },
  [TipoSimulacaoEnum.CREDITO_PAGAMETADE]: {
    [ProdutosEnum.IMOVEL]: { min: 100000, max: 700000 },
    [ProdutosEnum.CARRO]: { min: 30000, max: 400000 },
    [ProdutosEnum.MOTO]: { min: 10000, max: 120000 },
    [ProdutosEnum.SERVICO]: { min: 0, max: 0 },
    [ProdutosEnum.CAMINHAO]: { min: 100000, max: 400000 },
    [ProdutosEnum.MAQUINAS]: { min: 100000, max: 400000 },
  },
  [TipoSimulacaoEnum.PARCELA_REDUZIDA]: {
    [ProdutosEnum.IMOVEL]: { min: 100000, max: 700000 },
    [ProdutosEnum.CARRO]: { min: 30000, max: 400000 },
    [ProdutosEnum.MOTO]: { min: 10000, max: 120000 },
    [ProdutosEnum.SERVICO]: { min: 0, max: 0 },
    [ProdutosEnum.CAMINHAO]: { min: 100000, max: 400000 },
    [ProdutosEnum.MAQUINAS]: { min: 100000, max: 400000 },
  },
};

const CategoriasEnum = {
  1: {
    title: "Imóveis",
    description: "Novos ou usados",
    tipoPlano: TipoSimulacaoEnum.CREDITO_INTEGRAL,
    produtoCategoria: "imoveis",
  },
  2: {
    title: "Automóveis",
    description: "Novos ou seminovos",
    tipoPlano: TipoSimulacaoEnum.CREDITO_INTEGRAL,
    produtoCategoria: "automoveis",
  },
  3: {
    title: "Motocicletas",
    description: "Nacionais ou importadas",
    tipoPlano: TipoSimulacaoEnum.CREDITO_INTEGRAL,
    produtoCategoria: "motos",
  },
  4: {
    title: "Serviços",
    description: "Festas, viagens e mais",
    tipoPlano: TipoSimulacaoEnum.CREDITO_INTEGRAL,
    produtoCategoria: "servicos",
  },
  6: {
    title: "Pesados",
    description: "Caminhões e Equipamentos",
    tipoPlano: TipoSimulacaoEnum.CREDITO_INTEGRAL,
    produtoCategoria: "caminhoes_equipamentos",
  },
  20: {
    title: "Imóveis",
    description: "Novos ou usados",
    tipoPlano: TipoSimulacaoEnum.CREDITO_PAGAMETADE,
    produtoCategoria: "imoveis",
  },
  21: {
    title: "Automóveis",
    description: "Novos ou seminovos",
    tipoPlano: TipoSimulacaoEnum.CREDITO_PAGAMETADE,
    produtoCategoria: "automoveis",
  },
  22: {
    title: "Motocicletas",
    description: "Nacionais ou importadas",
    tipoPlano: TipoSimulacaoEnum.CREDITO_PAGAMETADE,
    produtoCategoria: "motos",
  },
  26: {
    title: "Pesados",
    description: "Caminhões e Equipamentos",
    tipoPlano: TipoSimulacaoEnum.CREDITO_PAGAMETADE,
    produtoCategoria: "caminhoes_equipamentos",
  },
  29: {
    title: "Imóveis",
    description: "Novos ou usados",
    tipoPlano: TipoSimulacaoEnum.PARCELA_REDUZIDA,
    produtoCategoria: "imoveis",
  },
  30: {
    title: "Automóveis",
    description: "Novos ou seminovos",
    tipoPlano: TipoSimulacaoEnum.PARCELA_REDUZIDA,
    produtoCategoria: "automoveis",
  },
  31: {
    title: "Motocicletas",
    description: "Nacionais ou importadas",
    tipoPlano: TipoSimulacaoEnum.PARCELA_REDUZIDA,
    produtoCategoria: "motos",
  },
};

const CategoriaPagamento = {
  CREDITO_INTEGRAL: {
    IMOVEL: 1,
    CARRO: 2,
    MOTO: 3,
    SERVICO: 4,
    CAMINHAO: 6,
    MAQUINAS: 6,
  },
  CREDITO_PAGAMETADE: {
    IMOVEL: 20,
    CARRO: 21,
    MOTO: 22,
    SERVICO: 0, // verificar qual é o id
    CAMINHAO: 26,
    MAQUINAS: 26,
  },
  PARCELA_REDUZIDA: {
    IMOVEL: 29,
    CARRO: 30,
    MOTO: 31,
    SERVICO: 0, // verificar qual é o id
    CAMINHAO: 32,
    MAQUINAS: 32,
  },
};

const Catalog = {
  generateBy: {
    CREDITO: 1,
    PARCELA: 2,
  },
  category: {
    1: "IM",
    2: "AN",
    3: "MT",
    4: "PS",
    6: "TM",
    20: "IM",
    21: "AN",
    22: "MT",
    26: "TM",
    29: "IM",
    30: "AN",
    31: "MT",
  },
};

const categoryNames = {
  1: "IMOVEL",
  2: "CARRO",
  3: "MOTO",
  4: "SERVICO",
  6: "CAMINHAO",
  20: "IMOVEL",
  21: "CARRO",
  22: "MOTO",
  26: "CAMINHAO",
  29: "IMOVEL",
  30: "CARRO",
  31: "MOTO",
  32: "CAMINHAO",
};

const categoryNameTranslate = {
  IM: "imoveis",
  AN: "automoveis",
  MT: "moto",
  PS: "servicos",
  TM: "caminhoes_equipamentos",
};

const planPaymentType = {
  Integral: "plano_integral",
  "Paga Metade": "plano_paga_metade",
  "Paga Reduzida": "plano_parcela_reduzida",
};

const grupoSituacao = {
  0: "Em andamento",
  1: "Em formação",
};

const metodosPagamentoEnum = {
  0: "CARTÃO",
  1: "BOLETO",
  5: "PIX",
};

const couponErrors = {
  CupomNaoEncontrado: "Cupom inexistente. Verifique o código.",
  ForaDaValidade: "Cupom fora da validade.",
  UnidadeNegocioInvalida: "Cupom não válido para esta loja.",
  CategoriaInvalida: "Cupom não válido para esta categoria.",
  CanalVendaInvalido: "Cupom não disponível para este tipo de compra.",
  FormaPagamentoInvalida: "Cupom não válido para esta forma de pagamento.",
  TipoDescontoInvalido: "Erro no tipo de desconto.",
  ValorExcedeLimite: "Compra acima do valor permitido para este cupom.",
  ValorInferiorMinimo: "Compra abaixo do valor mínimo para este cupom.",
  CupomJaExiste: "Cupom já cadastrado.",
  DataInvalida: "Data de validade inválida.",
  OfertaInvalida: "Oferta não válida.",
  CupomUtilizado: "Cupom já utilizado.",
  CupomInvalido: "Regra do cupom inválida.",
  RegraCupomInvalida: "Regra do cupom ausente.",
  1: "Cupom inexistente. Verifique o código.",
  2: "Cupom fora da validade.",
  3: "Cupom não válido para esta loja.",
  4: "Cupom não válido para esta categoria.",
  5: "Cupom não disponível para este tipo de compra.",
  6: "Cupom não válido para esta forma de pagamento.",
  7: "Erro no tipo de desconto.",
  8: "Compra acima do valor permitido para este cupom.",
  9: "Compra abaixo do valor mínimo para este cupom.",
  10: "Cupom já cadastrado.",
  11: "Data de validade inválida.",
  12: "Oferta não válida.",
  13: "Cupom já utilizado.",
  14: "Regra do cupom inválida.",
  15: "Regra do cupom ausente.",
};

export {
  ProdutosEnum,
  tipoPlanoNome,
  TipoSimulacaoEnum,
  valoresSimulacao,
  CategoriaPagamento,
  TipoBotEnum,
  ProdutosNomes,
  BOT_NAME,
  Catalog,
  categoryNames,
  CategoriasEnum,
  categoryNameTranslate,
  planPaymentType,
  ProdutosNomesCopy,
  planoNome,
  grupoSituacao,
  tipoPlanoNomeCased,
  metodosPagamentoEnum,
  couponErrors,
};
